export const ReturnAssessmentOptionText = 'Return Disclosure - More Information required';
export const ReturnDisclosureInputLabelText = 'Please provide instructions for the discloser.';
export const ManagementStrategyInputLabelText = 'Please provide a reason for your decision and any additional instructions.';


// WEBPACK FOOTER //
// ./app/constants/inputText.js